import * as React from 'react';
import { Image, ImageResizeOptions } from '../Image';
import { classes, st } from './ThumbnailImage.st.css';
/** ThumbnailImage is a component representing a relativity small image that typically act as target leading to a primary content (page/flow) */
export class ThumbnailImage extends React.Component {
    static { this.displayName = 'ThumbnailImage'; }
    static { this.defaultProps = {
        resize: ImageResizeOptions.cover,
    }; }
    render() {
        const { className, ...imageProps } = this.props;
        return React.createElement(Image, { className: st(classes.root, className), ...imageProps });
    }
}
//# sourceMappingURL=ThumbnailImage.js.map